import {openPolicySuccess, request, requestFailure, requestSuccess} from './request-maintenance.actions';
import {createReducer, on} from '@ngrx/store';
import {RequestMaintenanceState} from './request-maintenance.model';

export const requestMaintenanceFeatureKey = 'requestMaintenance';

export const initialState: RequestMaintenanceState = {
  policy: null,
  requesting: false,
  requestStatus: 'available'
};

export const requestMaintenanceReducer = createReducer(
  initialState,
  on(openPolicySuccess, (s, {policy}) => ({
    ...s,
    policy
  })),
  on(request, (s) => ({
    ...s,
    requesting: true
  })),
  on(requestSuccess, (s) => ({
    ...s,
    requesting: false,
    requestStatus: 'requested'
  })),
  on(requestFailure, (s) => ({
    ...s,
    requesting: false,
    requestStatus: 'unavailable'
  }))
);
